import { Crown, RefreshCw, Trophy } from "lucide-react";
import { useCallback, useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const CATEGORIES = [
  { key: "corporate", title: "Corporate Path", icon: Trophy },
  { key: "rebel", title: "Underground Path", icon: Crown },
  { key: "blackout", title: "Total Apocalypse", icon: Crown },
];

export function BingoLeaderboard({ refreshKey = 0 }) {
  const [boards, setBoards] = useState({ corporate: [], rebel: [], blackout: [] });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    setError("");
    try {
      const response = await fetch(`${API}/dolopals/bingo/leaderboard`, { cache: "no-store" });
      if (!response.ok) throw new Error("Leaderboard unavailable");
      setBoards(await response.json());
    } catch {
      setError("LEADERBOARD SIGNAL LOST — RETRY TRANSMISSION.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load, refreshKey]);

  return (
    <section className="bingo-leaderboard" data-testid="bingo-leaderboard">
      <div className="bingo-leaderboard-head">
        <div>
          <span>PUBLIC BOARD</span>
          <h3>Top Bingo Survivors</h3>
        </div>
        <button type="button" onClick={load} disabled={loading} data-testid="bingo-leaderboard-refresh-button">
          <RefreshCw size={13} className={loading ? "is-spinning" : ""} /> {loading ? "SYNCING" : "REFRESH"}
        </button>
      </div>
      {error ? <p className="bingo-leaderboard-error" data-testid="bingo-leaderboard-error">{error}</p> : null}
      <div className="bingo-leaderboard-grid">
        {CATEGORIES.map(({ key, title, icon: Icon }) => (
          <article className={`bingo-leaderboard-card board-${key}`} key={key} data-testid={`bingo-leaderboard-${key}`}>
            <h4><Icon size={15} /> {title}</h4>
            {boards[key]?.length ? (
              <ol>
                {boards[key].map((entry, index) => (
                  <li key={`${entry.tag}-${entry.updated_at || index}`} data-testid={`bingo-leaderboard-row-${key}-${index}`}>
                    <span className="leaderboard-rank">{String(index + 1).padStart(2, "0")}</span>
                    <div>
                      <strong>{entry.name}</strong>
                      <small>{entry.tag} · BLACKOUT {entry.blackout_progress}/25</small>
                    </div>
                    <b>×{entry.wins}</b>
                  </li>
                ))}
              </ol>
            ) : (
              <p className="leaderboard-empty">NO VERIFIED WINS YET.</p>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
